import { useTranslation } from "react-i18next";
import { codecName, riskyCodec, useFileCodec } from "../lib/video-codec.ts";
import { Icon } from "./Icon.tsx";

/**
 * Under a video picked for upload: a warning when its picture is in a codec some
 * browsers cannot show (H.265 above all), and how to export it so everyone sees it.
 * The upload still goes ahead if the author wants.
 */
export function ClipCodecNote({ file }: { file: File | null }) {
  const { t } = useTranslation();
  const codec = useFileCodec(file);
  if (!codec || !riskyCodec(codec)) return null;
  return (
    <div className="clip-codec-note" role="note">
      <Icon name="warning" size={16} />
      <div>
        <p>
          <b>{t("clipCodec.title", { codec: codecName(codec) })}</b> {codec.codec === "hevc" ? t("clipCodec.hevc") : t("clipCodec.other")}
        </p>
        <p className="small muted">{t("clipCodec.fix")}</p>
      </div>
    </div>
  );
}
